<template>
  <customModal :containerlg="true" @closeModal="closeModal">
    <template #title> Risk List - {{ data?.ctqid }} </template>

    <template #body>
      <div class="modal-scroll-body">
        <!-- Loading -->
        <div
          class="d-flex justify-content-center align-items-center py-5"
          v-if="loading"
        >
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>

        <!-- No Data -->
        <div class="text-center px-5 py-2" v-else-if="!riskList.length">
          <p class="text-muted">No risk data available</p>
        </div>

        <!-- Table Content -->
        <div v-else>
          <div class="table-responsive" style="overflow-x: auto;">
            <div class="ibox-title style_2 d-flex justify-content-between">
              <h5 class="mt-0">Risks</h5>
              <div class="position-relative align-self-center">
                <img
                  src="@/assets/img/create.png"
                  width="17"
                  alt="Add Risk"
                  style="cursor: pointer"
                  @click="openManageRiskModal()"
                />
                <div class="tool-tip">Add Risk</div>
              </div>
            </div>
            <table class="table table-striped table-bordered dataTables">
              <thead>
                <tr>
                  <th>Risk ID</th>
                  <th>Category</th>
                  <th>Sub-Category</th>
                  <th>Risk Statement</th>
                  <th>Risk Level</th>
                  <th>RPN</th>
                  <th class="text-center">Edit</th>
                  <th class="text-center">Mitigations</th>
                  <th class="text-center">KRI</th>
                  <th class="text-center">View</th>
                </tr>
              </thead>

              <tbody>
                <tr v-for="item in riskList" :key="item.id">
                  <td>
                    <span>{{ item.riskId }}</span>
                  </td>
                  <td>{{ item.riskCategory }}</td>
                  <td>{{ item.subCategory }}</td>
                  <td style="max-width: 400px; white-space: normal; word-break: break-word;">
                      <span>{{
                        item.expanded
                          ? item.riskStatement
                          : truncate(item.riskStatement)
                      }}</span>
                      <a
                        v-if="
                          item.riskStatement && item.riskStatement.length > 120
                        "
                        class="more-less-link ms-1"
                        @click.stop="toggleExpand(item)"
                      >
                        {{ item.expanded ? "less" : "more" }}
                      </a>
                  </td>
                  <td>
                    <span :class="riskLevelBadgeClass(item.riskLevel)">{{
                      item.riskLevel
                    }}</span>
                  </td>
                  <td>{{ item.rpn }}</td>
                  <td class="text-center">
                    <i
                      class="fa fa-edit edit-delete"
                      title="Edit Risk"
                      @click="openManageRiskModal(item)"
                    >
                    </i>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-eye edit-delete"
                      title="View Mitigations"
                      @click="ViewMitigation(item)"
                    >
                    </i>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-eye edit-delete"
                      title="View KRI's"
                      @click="viewKriForRisk(item)"
                    >
                    </i>
                  </td>
                  <td class="text-center">
                    <i
                      class="fa fa-eye edit-delete"
                      title="View Risk"
                      @click="viewRisk(item)"
                    >
                    </i>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- Pagination -->
          <div class="row mx-0 mt-3" v-if="totalPages > 1">
            <div class="col-12 d-flex justify-content-end">
              <VPagination
                v-model="currentPage"
                :pages="totalPages"
                :range-size="1"
                active-color="#618bd7"
                @update:modelValue="loadPage"
              />
            </div>
          </div>
        </div>
      </div>
    </template>
  </customModal>

  <KriInfoModal
    v-if="showKriModal"
    :data="selectedCtqForKri"
    @closeModal="closeKriModal"
  />

  <MitigationInfoModal
    v-if="showMitigationModal"
    :data="selectedCtqForMitigation"
    fromPage="riskListModal"
    @closeModal="closeMitigationModal"
  />

  <ManageRiskItemModal
    v-if="showManageRiskModal"
    :riskEditData="riskEditData"
    :ctqData="data"
    fromPage="CTQ Registry"
    @closeModal="closeManageRiskModal"
    @reloadList="reloadRiskList"
  />

  <ViewRiskInfoModal
    v-if="showViewRiskModal"
    :data="selectedRiskForView"
    @closeModal="closeViewRiskModal"
  />
</template>

<script src="./RiskListModal.js"></script>
<style scoped>  
  .ibox-title {
    padding: 6px 15px 6px 15px;
    min-height: 34px;
  }
  .position-relative .tool-tip {
    right: 18px;
    top: 0px;
}
  </style>